import Vue from 'vue'
import Router, {Route} from 'vue-router'
import { isUserLoggedInGuard, loginPageGuard, rootPageGuard, tenantRedirectionGuard } from '@/router/guards'
import LoginPage from '@/pages/LoginPage.vue'
import DashboardPage from '@/pages/DashboardPage.vue'
import SettingsPage from '@/pages/SettingsPage.vue'
import DailyReservationPage from '@/pages/DailyReservationPage.vue'
import FoodDatabasePage from '@//pages/FoodDatabasePage.vue'
import BoarderManagementPage from '@/pages/BoarderManagementPage.vue'
import BoarderGroupPage from "@/pages/settings/BoarderGroupPage.vue";
import BillingTab from "@/pages/settings/BillingTab.vue";
import CalendarPage from "@/pages/CalendarPage.vue"
import DailymenuPage from "@/pages/DailymenuPage.vue";
import BillingPage from "@/pages/BillingPage.vue";
import BankTransferPage from "@/pages/BankTransferPage.vue";
import DebtorsPage from "@/pages/DebtorsPage.vue";
import moment from "moment";
import BusinessPage from "@/pages/BusinessPage.vue";
import DiscountPage from "@/pages/settings/DiscountPage.vue";
import RequestsPage from "@/pages/RequestsPage.vue";
import BusinessReservationSummary from "@/components/BusinessReservationSummary.vue";
import SmartLinksPage from "@/pages/SmartLinksPage.vue";
import StatisticsPage from "@/pages/StatisticsPage.vue";
import RatingStatisticsPage from "@/pages/RatingStatisticsPage.vue";
import RedirectToNewAddressPage from '@/pages/RedirectToNewAddressPage.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
    {
      path: '/',
      name: 'Root',
      beforeEnter: rootPageGuard
    },
    {
      path: '/login',
      name: 'Login',
      beforeEnter: loginPageGuard,
      component: LoginPage
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      beforeEnter: isUserLoggedInGuard,
      component: DashboardPage
    },
    {
      path: '/settings',
      name: 'Settings',
      beforeEnter: isUserLoggedInGuard,
      component: SettingsPage
    },
    {
      path: '/settings/boarder-group',
      name: 'Settings/BoarderGroup',
      beforeEnter: isUserLoggedInGuard,
      component: BoarderGroupPage,
    },
    {
      path: '/settings/billing',
      name: 'Settings/Billing',
      beforeEnter: isUserLoggedInGuard,
      component: BillingTab,
    },
    {
      path: '/reservation',
      name: 'Reservations',
      beforeEnter: isUserLoggedInGuard,
      component: DailyReservationPage
    },

    {
      path: '/rating',
      name: 'Rating',
      beforeEnter: isUserLoggedInGuard,
      component: RatingStatisticsPage
    },
    {
      path: '/boarder-management',
      name: 'Reservations',
      beforeEnter: isUserLoggedInGuard,
      component: BoarderManagementPage
    },
    {
      path: '/food-database',
      name: 'FoodDatabase',
      beforeEnter: isUserLoggedInGuard,
      component: FoodDatabasePage
    },
    {
      path: '/dailymenu/:isoWeek?/:date?',
      name: 'Dailymenu',
      beforeEnter: isUserLoggedInGuard,
      component: DailymenuPage,
      props: (route: Route) => ({
        isoWeek: route.params.isoWeek,
        date: route.params.date && moment(route.params.date).toDate() || undefined
      }),
    },
    {
      path: '/calendar',
      name: 'Calendar',
      beforeEnter: isUserLoggedInGuard,
      component: CalendarPage
    },
    {
      path: '/billing',
      name: 'BillingPage',
      beforeEnter: isUserLoggedInGuard,
      component: BillingPage
    },
    {
      path: '/bank-transaction',
      name: 'BankTransfer',
      beforeEnter: isUserLoggedInGuard,
      component: BankTransferPage
    },
    {
      path: '/debtors',
      name: 'DebtorsPage',
      beforeEnter: isUserLoggedInGuard,
      component: DebtorsPage
    },
    {
      path: '/business',
      name: 'BusinessPage',
      beforeEnter: isUserLoggedInGuard,
      component: BusinessPage
    },
    {
      path: '/discount',
      name: 'DiscountPage',
      beforeEnter: isUserLoggedInGuard,
      component: DiscountPage
    },
    {
      path: '/delivery',
      name: 'BusinessReservationSummary',
      beforeEnter: isUserLoggedInGuard,
      component: BusinessReservationSummary,
      props: (route: Route):any => ({
        date: route.params.date && moment(route.params.date).toDate(),
        customer: route.params.customer
      }),

    },
    {
      path: '/requests',
      name: 'RequestsPage',
      beforeEnter: isUserLoggedInGuard,
      component: RequestsPage
    },
    {
      path: '/smart-links',
      name: 'SmartLinksPage',
      beforeEnter: isUserLoggedInGuard,
      component: SmartLinksPage
    },
    {
      path: '/statistics',
      name: 'StatisticsPage',
      beforeEnter: isUserLoggedInGuard,
      component: StatisticsPage
    },
    {
      path: '/redirect-to-new-address',
      name: 'RedirectToNewAddress',
      beforeEnter: isUserLoggedInGuard,
      component: RedirectToNewAddressPage
    },
    {
      path: '*',
      redirect: '/dashboard'
    }

  ]
})

router.beforeEach(tenantRedirectionGuard)
export default router
